var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "px-0 pt-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pt-0", attrs: { cols: "12" } },
            [
              _vm.game != null &&
              _vm.gameFlowDataPerPhasesItems.length > 0 &&
              _vm.chartData != null
                ? _c("GameFlowChart", {
                    attrs: {
                      id: "xTChart",
                      game: _vm.game,
                      xTChart: _vm.xTChart,
                      gameFlowDataPerPhasesItems:
                        _vm.gameFlowDataPerPhasesItems,
                      chartData: _vm.chartData,
                      chartId: _vm.chartId,
                      language: _vm.currentUserLanguage,
                    },
                    on: {
                      loaded: function ($event) {
                        return _vm.onLoaded($event)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      !(
        _vm.game != null &&
        _vm.gameFlowDataPerPhasesItems.length > 0 &&
        _vm.chartData != null
      )
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { staticClass: "pt-0", attrs: { cols: "12" } },
                [
                  _c("v-skeleton-loader", {
                    staticClass: "flex-grow-1 elevation-2",
                    attrs: { type: "article" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { staticClass: "pt-0 pr-1", attrs: { cols: "5" } },
                [
                  _c("v-skeleton-loader", {
                    staticClass: "flex-grow-1 elevation-2",
                    attrs: { type: "list-item@8" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { staticClass: "pt-0 pl-1", attrs: { cols: "7" } },
                [
                  _c("v-skeleton-loader", {
                    staticClass: "flex-grow-1 elevation-2",
                    attrs: { type: "card" },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }